import { Component, OnInit } from '@angular/core';
import { faLockAlt } from '@fortawesome/pro-solid-svg-icons';
@Component({
  selector: 'dx-app-unauthorized-page',
  templateUrl: './app-unauthorized-page.component.html',
  styleUrls: ['./app-unauthorized-page.component.scss']
})
export class AppUnauthorizedPageComponent implements OnInit {
faLockAlt = faLockAlt;
  constructor() { }

  ngOnInit(): void {
  }

}
